import 'promise-polyfill/src/polyfill'
import { environment } from './config/environment.config'
import { persistService } from './services/persist.service'
import { userAgentIsInternetExplorer } from './utils/ie.utils'
// @READ Requires full path due to module loading order

/**
 * Run the application.
 *
 * @return {Promise<void>}
 */

const main = async (): Promise<void> => {
  // Import polyfills for Internet Explorer
  if (userAgentIsInternetExplorer()) {
    console.log('∆ Older browser detected')
    await import('./polyfills')
    console.log('√ Imported polyfills')
  }

  // Disable styles in dev if DEV_HIDE_WIDGETS is enabled
  const { dev: { hideWidgets }, isDev } = environment // Changed from CONFIG.environment for IE10 support
  if (isDev && hideWidgets) {
    import('./styles/_dev.scss' as string)
  }

  // Hydrate persist service
  persistService.hydrate()

  // Import app
  import('./mounting-point')
}

main()
